import Bugsnag from '@bugsnag/js';
import { config } from 'config';

const {
  bugsnag: {
    apiKey,
    appType,
    appVersion,
    enabledReleaseStages,
    releaseStage,
    plugins,
    metadata,
  },
} = config;

export default () => {
  Bugsnag.start({
    apiKey,
    plugins,
    enabledReleaseStages,
    releaseStage,
    appType,
    appVersion,
    metadata,
    // Filter out browser extension errors that aren't from our code
    onError: (event) => {
      // https://docs.bugsnag.com/platforms/javascript/customizing-error-reports/#errors
      const message = event.errors[0]?.errorMessage || '';

      // Ignore browser extension errors
      if (message.includes('runtime.sendMessage')
        || message.includes('chrome-extension://')
        || message.includes('moz-extension://')) {
        return false; // Don't send to Bugsnag
      }

      // Normalize file URLs for source map matching
      const urlTransformations: string[] = [];
      event.errors.forEach((error) => {
        error.stacktrace.forEach((frame) => {
          if (!frame.file) return;

          const originalUrl = frame.file;

          // Replace webkit-masked-url with actual origin
          if (frame.file.includes('webkit-masked-url://hidden/')) {
            frame.file = frame.file.replace('webkit-masked-url://hidden/', window.location.origin + '/');
            urlTransformations.push(`webkit-masked: ${originalUrl} → ${frame.file}`);
          }

          // Convert relative URLs to absolute
          if (frame.file.startsWith('/') && !frame.file.startsWith('//')) {
            frame.file = window.location.origin + frame.file;
            urlTransformations.push(`relative: ${originalUrl} → ${frame.file}`);
          }
        });
      });

      // Add metadata about URL transformations if any occurred
      if (urlTransformations.length > 0) {
        event.addMetadata('source_maps', {
          urlTransformations,
          userAgent: navigator.userAgent,
          origin: window.location.origin,
        });
      }

      return true;
    },
  });

  return Bugsnag.getPlugin('react');
};
